module.exports = __webpack_public_path__ + "img/imageplaceholder.6507a41.svg";